import { ComponentPropsWithoutRef } from 'react';
import { RequireAuth } from 'react-auth-kit';
import { ROUTES } from 'router/routes';

type ProtectedRouteProps = Pick<ComponentPropsWithoutRef<typeof RequireAuth>, 'children'>;

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => (
  <RequireAuth loginPath={ROUTES.home}>{children}</RequireAuth>
);
